package com.milta.core.localization.translations.it

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Scansiona un documento",
    reviewTitle = "Verifica i dati",
    fileSentSuffix = "appena inviata",
    analysingTitle = "Lettura del documento…",
    analysingSubtitle = "Stiamo rilevando le consegne nella foto. Bastano pochi secondi.",
    deliveriesDetectedSuffix = "consegne rilevate",
    toCompleteSuffix = "da completare",
    reviewHint = "Completa le consegne segnalate prima di aggiungerle al percorso",
    addressMissingWarning = "Indirizzo mancante",
    nameMissingWarning = "Nome mancante",
    recipientMissingPlaceholder = "Destinatario non rilevato",
    phoneNotDetectedNote = "Telefono non rilevato — l'aggiunta non è bloccata",
    deadlineLabelPrefix = "Orario limite",
    completeLinkLabel = "Completa",
    addToRouteButtonPrefix = "Aggiungi al percorso",
    correctionRecipientLabel = "Destinatario",
    correctionAddressLabel = "Indirizzo",
    correctionPhoneLabel = "Telefono",
    correctionDeadlineLabel = "Orario limite",
    unreadableTitle = "Foto illeggibile.",
    unreadableMessage = "Non abbiamo rilevato nessuna consegna in questa immagine — scatta una foto ben inquadrata e ben illuminata.",
    retakePhotoButton = "Scatta un'altra foto",
    manualEntryButton = "Inserisci manualmente",
    rateLimitTitle = "Troppe scansioni effettuate di recente.",
    rateLimitMessage = "Riprova un po' più tardi, oppure completa questa consegna manualmente nel frattempo.",
    rateLimitRetakeUnavailableLabel = "Scatta un'altra foto — non disponibile per il momento",
)
